<template>
    <div
        class="content-media-header content-video-header"
        :class="[
            { 'banner-enabled': !!variant },
            variant ? `text-theme-${variant.textTheme ?? 'light'}` : ''
        ]"
    >
        <!-- Background Video -->
        <video
            v-if="variant"
            :key="variant.url"
            class="fill-width fill-height"
            autoplay
            muted
            loop
            playsinline
            :poster="variant.poster ?? undefined"
        >
            <source
                :src="variant.url"
                :type="variant.mime"
            >
            <track kind="captions">
        </video>

        <!-- Header Content -->
        <div class="slot-header max-container mx-auto px-4 px-md-6 pt-4">
            <slot />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import type { BannerVideoVariant } from '~/types';

    defineProps({
        variant: {
            type: Object as PropType<Nilish<BannerVideoVariant>>,
            default: null
        }
    });
</script>

<style lang="scss">
.content-video-header.banner-enabled {
    .video-toggle {
        filter: invert(1);
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 1;
    }
}
</style>
